// react
import { useState, useEffect } from "react";
// kendo
import { State } from "@progress/kendo-data-query";
// common
import PageLayout from "../../../common/shell/PageLayout";
import TaskLayout from "../../../common/shell/TaskLayout";
// me
import { IFilterViewModel, IRootViewModel, RootViewModel } from "./models/models";
import * as actions from "./actions";
import FilterView from "./views/FilterView";
import ChartView from "./views/ChartView";
import ListView from "./views/ListView";

const initialFilterState: IFilterViewModel = {
    applicationTrackingType: undefined,
    isCompleted: false,
};

const initialGridState: State = {
    sort: [
        { field: "implementedDate", dir: "desc" },
        { field: "lodgedDate", dir: "desc" },
    ],
    skip: 0,
    take: 10,
};

export default function Controller() {
    // initial state
    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());
    const [filterState, setFilterState] = useState<IFilterViewModel>(initialFilterState);
    const [gridState, setGridState] = useState<State>(initialGridState);

    // on mount
    useEffect(() => {
        actions.initialise(initialFilterState, setVm);
    }, []);

    function refresh(values: IFilterViewModel) {
        // update vm and refresh data
        actions.initialise(values, setVm);
        // reset grid state
        setGridState(initialGridState);
    }

    function handleFilterStateChanged(values: IFilterViewModel) {
        setFilterState(values);
    }

    // refresh using filter state
    function handleShowFilter() {
        refresh(filterState);
    }

    // reset filter state and refresh
    function handleResetFilter() {
        setFilterState(initialFilterState);
        refresh(initialFilterState);
    }

    // set filter state and refresh
    function handleSeriesClick(values: IFilterViewModel) {
        setFilterState(values);
        refresh(values);
    }

    return (
        <PageLayout title={["OEI Application Tracking"]}>
            <TaskLayout isBusy={vm.isBusy} error={vm.error}>
                <FilterView
                    filterState={filterState}
                    applicationTrackingTypes={vm.applicationTrackingTypes}
                    onFilterStateChanged={handleFilterStateChanged}
                    onShowFilter={handleShowFilter}
                    onResetFilter={handleResetFilter}
                />
                <ChartView vm={vm} onSeriesClick={handleSeriesClick} />
                <ListView listItems={vm.applicationList} gridState={gridState} setGridState={setGridState} />
            </TaskLayout>
        </PageLayout>
    );
}
